<template>
  <ubi-page-container wide-main-content>
    <template v-slot:page-actions>
      <el-button class="inline" @click="exporterDiffusion">
        <downloadexcel :data="exporterDiffusion" type="xls" :name="nomFichierExport">
          {{ $t("portals.report.exportResults") }}
        </downloadexcel>
      </el-button>
    </template>
    <div>
      <ubi-panel :title="$t('portals.report.globalTitle')" size="sm">
        <el-row>
          <el-col :lg="16" :md="12">
            <strong>{{ $t("portals.report.lastUpdateAds") }}</strong>
            <p>{{ convertDate(getStatisticsDateDerniereMajAnnonces) }}</p>
            <el-row>
              <el-col :lg="12" class="mb-3">
                <ubi-stat-value icon="direction" :value="getStatisticsNbPortailsActifs" :sub-value="getStatisticsNbPortailsTotal" :label="$t('portals.report.activePortals')" />
              </el-col>
              <el-col :lg="12" class="mb-3" v-loading="getLoadingPourcentageTotalDiffusion">
                <ubi-stat-value icon="announcement" v-if="getStatisticsPourcentageAnnoncesDiffusees != null" :value="getStatisticsPourcentageAnnoncesDiffusees + '%'" :label="$t('portals.report.globalAdsDiffused')" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="12">
            <div class="text-muted" style="text-align: center;">
              <el-image v-if="sitimmoUser.logoUrl != null" :src="sitimmoUser.logoUrl" :srcset="sitimmoUser.logoUrl" width="350" />
              <ubi-icon v-else class="no-photo" name="home" size='150' />
              <p>{{ sitimmoUser.nom }}</p>
            </div>
          </el-col>
        </el-row>
      </ubi-panel>
      <ApiSearchForm
        :business-domain="businessDomain"
        :route="searchRoute"
        :user-context="searchContext"
        @search="handleSearchFromApi"
        @reset="handleResetFromApi"
      />
      <ubi-panel>
        <div>
          <PaginationPage  :total="getTotalReportDiffusion"
                           :currentPage.sync="currentPage"
                           :pageSize.sync="pageSize"
                           @update:currentPage="fetchPage"
                           @update:pageSize="fetchPageSize"
          />
        </div>
        <el-button type="mini" slot="actions">
          <downloadexcel :data="exporterDiffusion" type="xls" :name="nomFichierExport">{{ $t("portals.report.exportResults") }}</downloadexcel>
        </el-button>
        <el-table
            :data="currentReportDiffusion"
            v-loading="getLoadingReportDiffusion"
            :element-loading-text="$t('portals.list.chargementDonnees')"
        >
          <el-table-column type="expand" >
            <template v-slot="{ row: report }">
              <div v-if="report.messages.length > 0">
                <p class="mb-0" v-for="message in report.messages" :key="message.idUniq + message.annonce">
                  <ubi-icon name="alert" class="text-warning ml-2" v-if="message.codeInterne === 'WARN'" />
                  <ubi-icon name="close" class="text-white bg-danger rounded-circle ml-2" v-if="message.codeInterne === 'ERROR'" />
                  <em v-if="message.annonce">
                    <el-button type="text" class="lienRefRapportErreur" @click="getIdThenGoToAd(message.annonce)">
                      {{ message.annonce }}
                    </el-button>
                    - {{ message.message }}
                  </em>
                  <em v-else>{{ message.message }}</em>
                </p>
              </div>
              <div v-else>
                {{ $t('portals.report.noMessage') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.report.columnLogo')" min-width="120">
            <template v-slot="{ row: report }">
              <img alt="" width="70" :src="getLogo(report)" :srcset="getLogo(report)" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.report.columnPortal')">
            <template v-slot="{ row: report }">
              <router-link :to="{ name: 'report', params: { portal: report.nomCodeFluxPartenaire } }">{{ report.nomFluxPartenaire }}</router-link>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.report.columnDateDiffusion')" width="190" v-if="browserContext.up('lg')">
            <template v-slot="{ row: report }">
              <div>{{ convertDate(report.endDate) }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.report.columnAdsDiffused')" width="160" align="right">
            <template v-slot="{ row: report }">
              <div v-if="report.bilan.bilanAnnonces && !report.bilan.bilanAnnonces.diffusees && (report.bilan.bilanAnnonces.traites > 0)">
                {{ (report.bilan.bilanAnnonces.traites - report.bilan.bilanAnnonces.non_valides) }} / {{ (report.bilan.bilanAnnonces.traites) }} -
                <span
                    :class="{
                    'font-weight-bold': (((report.bilan.bilanAnnonces.traites - report.bilan.bilanAnnonces.non_valides) / (report.bilan.bilanAnnonces.traites))*100) < 100,
                    'text-danger': (((report.bilan.bilanAnnonces.traites - report.bilan.bilanAnnonces.non_valides) / (report.bilan.bilanAnnonces.traites))*100) <= 50,
                    'text-warning': (((report.bilan.bilanAnnonces.traites - report.bilan.bilanAnnonces.non_valides) / (report.bilan.bilanAnnonces.traites))*100) <= 75
                  }">
                  {{ Math.ceil(((report.bilan.bilanAnnonces.traites - report.bilan.bilanAnnonces.non_valides) / (report.bilan.bilanAnnonces.traites))*100) }}%
                </span>
              </div>
              <div v-else-if="report.bilan.bilanAnnonces && report.bilan.bilanAnnonces.diffusees && (report.bilan.bilanAnnonces.traites > 0)">
                {{ (report.bilan.bilanAnnonces.diffusees) }} / {{ (report.bilan.bilanAnnonces.traites) }} -
                <span
                    :class="{
                    'font-weight-bold': (((report.bilan.bilanAnnonces.diffusees) / (report.bilan.bilanAnnonces.traites))*100) < 100,
                    'text-danger': (((report.bilan.bilanAnnonces.diffusees) / (report.bilan.bilanAnnonces.traites))*100) <= 50,
                    'text-warning': (((report.bilan.bilanAnnonces.diffusees) / (report.bilan.bilanAnnonces.traites))*100) <= 75
                  }">
                  {{ Math.ceil(((report.bilan.bilanAnnonces.diffusees) / (report.bilan.bilanAnnonces.traites))*100) }}%
                </span>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <PaginationPage  :total="getTotalReportDiffusion"
                           :currentPage.sync="currentPage"
                           :pageSize.sync="pageSize"
                           @update:currentPage="fetchPage"
                           @update:pageSize="fetchPageSize"
          />
        </div>
      </ubi-panel>
    </div>
  </ubi-page-container>
</template>

<script>
import UbiPanel from '@/components/Panel.vue'
import UbiIcon from '@/components/Icon.vue'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { convertDate } from '@/helpers/functions/convertDate'
import { mapGetters } from 'vuex'
import moment from 'moment/moment'
import UbiStatValue from '@/components/statistics/StatValue.vue'
import downloadexcel from 'vue-json-excel'
import PaginationPage from '@/components/ui/PaginationPage.vue'
import { getCategoryLabel } from '@/helpers/functions/categoryFilterById'
import UbiPageContainer from '@/components/PageContainer.vue'

export default {
  name: 'GlobalDiffusionReport',
  inject: ['browserContext'],
  components: {
    UbiPageContainer,
    PaginationPage,
    downloadexcel,
    UbiStatValue,
    UbiIcon,
    UbiPanel,
    ApiSearchForm
  },
  data () {
    return {
      nomFichierExport: this.$t('portals.report.filenameExportDiffusion') + '.xls',
      listCategories: [],
      currentPage: 1,
      pageSize: 10,
      businessDomain: 'immo',
      searchRoute: '/global-report'
    }
  },
  computed: {
    ...mapGetters('globalDiffusionReport', ['getLogoByPortal']),
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    searchContext () {
      return {
        user: this.$store.state.app.user,
        sitimmoUser: this.$store.state.app.sitimmoUser
      }
    },
    getLoadingReportDiffusion () {
      return this.$store.getters['globalDiffusionReport/getLoadingReportDiffusion']
    },
    getReportDiffusion () {
      return Object.values(this.$store.getters['globalDiffusionReport/getReportDiffusion'])
    },
    currentReportDiffusion () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (Array.isArray(this.getReportDiffusion)) {
        return this.getReportDiffusion.slice(start, end)
      }
      return []
    },
    localFilters () {
      return this.$store.getters['globalDiffusionReport/getFilters']
    },
    getTotalReportDiffusion () {
      return this.$store.getters['globalDiffusionReport/getTotalReportDiffusion']
    },
    getStatisticsDateDerniereMajAnnonces () {
      return this.$store.getters['globalDiffusionReport/getStatisticsDateDerniereMajAnnonces']
    },
    getStatisticsNbPortailsActifs () {
      return this.$store.getters['globalDiffusionReport/getStatisticsNbPortailsActifs']
    },
    getStatisticsNbPortailsTotal () {
      return this.$store.getters['globalDiffusionReport/getStatisticsNbPortailsTotal']
    },
    getStatisticsPourcentageAnnoncesDiffusees () {
      return this.$store.getters['globalDiffusionReport/getPourcentageTotalDiffusion']
    },
    getLoadingPourcentageTotalDiffusion () {
      return this.$store.getters['globalDiffusionReport/getLoadingPourcentageTotalDiffusion']
    },
    exporterDiffusion () {
      this.$store.dispatch('globalDiffusionReport/exporterDiffusion')
      return this.$store.getters['globalDiffusionReport/getMessagesExportDiffusion']
    }
  },
  methods: {
    convertDate,
    getIdThenGoToAd (reference) {
      const post = this.getPostByReference(reference)
      if (post) {
        this.$router.push({ name: 'post-view', params: { post: post.id } })
      } else {
        this.$message({ type: 'warning', message: 'Votre annonce n\' existe plus.' })
      }
    },
    getLogo (report) {
      return this.getLogoByPortal(report.nomCodeFluxPartenaire)
    },
    fileName () {
      const date = moment().format('YYYY_MM_DD')
      this.nomFichierExport = this.$t('portals.report.filenameExportDiffusion') + '_' + date + '.xls'
    },
    handleSearchFromApi (filters) {
      const category = getCategoryLabel(this.$store, filters.category)
      this.$store.commit('globalDiffusionReport/setFiltersActive', true)
      this.$store.commit('globalDiffusionReport/setFilters', { key: 'search', value: filters.search || '' })
      this.$store.commit('globalDiffusionReport/setFilters', { key: 'category', value: category || null })
      this.$store.commit('globalDiffusionReport/setFilters', { key: 'gratuit', value: filters.gratuit || '' })
      this.$store.dispatch('globalDiffusionReport/loadRapportGlobalDiffusion')
    },
    handleResetFromApi () {
      this.$store.commit('globalDiffusionReport/setFiltersActive', false)
      this.$store.commit('globalDiffusionReport/setResetFilters')
      this.$store.dispatch('globalDiffusionReport/loadRapportGlobalDiffusion')
    },
    fetchPage (page) {
      this.currentPage = page
    },
    fetchPageSize (size) {
      this.pageSize = size
      this.currentPage = 1
    }
  },
  mounted () {
    this.$store.dispatch('globalDiffusionReport/loadExcludedCodeNames')
    this.$store.dispatch('globalDiffusionReport/loadEnteteStatistics', null, { root: true })
    this.$store.dispatch('globalDiffusionReport/loadPourcentageTotalDiffusion')
    this.$store.dispatch('globalDiffusionReport/loadRapportGlobalDiffusion', null, { root: true })
  },
  beforeMount () {
    this.$store.dispatch('donnees/loadCategories')
  }
}
</script>
